$(document).ready(function () {
  var loaded = false;
  if (typeof IntersectionObserver !== 'undefined') {
    var observer = new IntersectionObserver(function (entries, observer) {
      if (entries[0].intersectionRatio != 0 && !loaded) {
        $.get(window.carOffersListUrl, function (response) {
          $('.car-offers-wrapper').html(response.view);

          loaded = true;
          createSlider();
          lazyload();
        });
      }
    }, {
      threshold: 0.2,
    });
    observer.observe(document.querySelector('.car-offers-wrapper'));
  }
})

function createSlider() {
  const isMobile = window.innerWidth < 768;

  const config = {
    dots: false,
    arrow: !isMobile,
    focusOnSelect: true,
    infinite: false,
    speed: 500,
    slidesToShow: !isMobile ? 5.2 : 4.6,
    slidesToScroll: 1,
    prevArrow: '<button class="slide-arrow prev-arrow"><i class="fa-solid fa-chevron-left"></i></button>',
    nextArrow: '<button class="slide-arrow next-arrow"><i class="fa-solid fa-angle-right"></i></button>',
  }

  if (!isMobile) {
    $('.rental-popular-cars').slick({
      ...config,
      swipe: false,
      touchMove: false,
      draggable: false,
      responsive: [
        {
          breakpoint: 1600,
          settings: {
            slidesToShow: 3.6,
          }
        },
        {
          breakpoint: 1280,
          settings: {
            slidesToShow: 2.8,
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2.5,
            arrow: false,
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1.1,
            arrow: false,
            speed: 300,
            easing: 'ease',
            touchThreshold: 20,
            touchMove: true,
            afterChange: function (slick) {
              if ('ontouchstart' in document && navigator.userAgent.match(/Android/)) {
                var transitionDuration = $('.rental-popular-cars').css('transitionDuration');
                setTimeout(function () {
                  $('.rental-popular-cars').animate({
                    scrollLeft: slick.currentSlide * $(slick.$popular_car).width()
                  }, transitionDuration);
                }, 200);
              }
            }
          }
        },
      ]
    });
    $('.rental-popular-cars .go-to-department-btn').each(function () {
      $(this).on('click', function (evt) {
        evt.stopPropagation();
        evt.stopImmediatePropagation();
      })
    });
  } else {
    $('.mobile-rental-slider').slick({
      ...config,
      touchThreshold: 5,
      responsive: [
        {
          breakpoint: 1600,
          settings: {
            slidesToShow: 3.6,
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2.3,
            arrow: false,
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1.1,
            arrow: false,
            speed: 300,
            easing: 'ease',
            touchThreshold: 20,
            touchMove: true,
            afterChange: function (slick) {
              if ('ontouchstart' in document && navigator.userAgent.match(/Android/)) {
                var transitionDuration = $('.rental-popular-cars').css('transitionDuration');
                setTimeout(function () {
                  $('.rental-popular-cars').animate({
                    scrollLeft: slick.currentSlide * $(slick.$popular_car).width()
                  }, transitionDuration);
                }, 200);
              }
            }
          }
        },
      ]
    })
  }
}
